<template>
  <div>
    <div class="evaluate_box">
      <h2 class="clearfix_"><span class="fl">下单时间：</span><em class="fl">{{time}}</em><span class="fl">商户：</span><em class="fl">{{tenantName}}</em></h2>
      <div class="evaluate_item">
        <ul>
          <li v-for="(item,index) in orderGoodsItem" :key="index" class="clearfix_">
            <div class="fl evaluate_goods">
              <div class="evaluate_item_pic"><img :src="item.goodsUrl" alt=""></div>
              <p @click="toGoods(item.dom,item.goodsId,item.goodsName)" class="evaluate_item_name">{{item.goodsName}}</p>
              <p class="evaluate_item_name">{{item.goodsUnitName}} {{item.property1}}</p>
              <p class="evaluate_item_price">¥{{item.salesMoney}} x {{item.num}}</p>
            </div>
            <div class="fl evaluate_text">
              <div class="evaluate_describe">
                <textarea maxlength="200" v-model="item.txt"></textarea>
                <p>{{item.txt.length}}/200</p>
              </div>
              <div v-show="!isAppend" class="evaluate_score clearfix_">
                <div style="line-height:18px;" class="fl">商品评分：</div>
                <div class="fl">
                  <img @click="goodsScoreFn(index,val.id,idx)" v-for="(val,idx) in item.goodsScore" :key="idx" :src="val.isChecked?star1:star2" alt="">
                  <span v-show="item.level>=4">好评</span>
                  <span v-show="item.level==3">中评</span>
                  <span v-show="item.level<=2">差评</span>
                </div>
              </div>
              <div class="evaluate_text_upload">
                <div>
                  <button>上传图片</button>
                  <span style="color:#999;">还能上传{{5-item.imgList.length}}张图片</span></div>
                <ul class="evaluate_text_upload_box">
                  <li v-for="(val,idx) in item.imgList" :key="idx" class="fl"><img :src="val" alt=""></li>
                  <li class="fl evaluate_text_upload_plus">
                    <input class="file img_btn" multiple type="file" accept="image/png,image/gif,image/jpeg" @change="uploadImgFn($event,item.id)"/>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
        <div class="submit_box"><button @click="submit">提交</button></div>
        <div v-show="!isAppend" class="scoreList">
          <div class="evaluate_score clearfix_">
            <div style="line-height:18px;" class="fl">商品评分：</div>
            <div class="fl">
              <img @click="allGoodsScoreFn(item.id,index)" v-for="(item,index) in allGoodsScore" :key="index" :src="item.isChecked?star1:star2" alt="">
              <span v-show="allGoodsScoreLevel>=4">好评</span>
              <span v-show="allGoodsScoreLevel==3">中评</span>
              <span v-show="allGoodsScoreLevel<=2">差评</span>
            </div>
          </div>
          <div class="evaluate_score clearfix_">
            <div style="line-height:18px;" class="fl">服务评分：</div>
            <div class="fl">
              <img @click="serviceScoreFn(item.id,index)" v-for="(item,index) in serviceScore" :key="index" :src="item.isChecked?star1:star2" alt="">
              <span v-show="serviceScoreLevel>=4">好评</span>
              <span v-show="serviceScoreLevel==3">中评</span>
              <span v-show="serviceScoreLevel<=2">差评</span>
            </div>
          </div>
          <div class="evaluate_score clearfix_">
            <div style="line-height:18px;" class="fl">物流评分：</div>
            <div class="fl">
              <img @click="logisticsScoreFn(item.id,index)" v-for="(item,index) in logisticsScore" :key="index" :src="item.isChecked?star1:star2" alt="">
              <span v-show="logisticsScoreLevel>=4">好评</span>
              <span v-show="logisticsScoreLevel==3">中评</span>
              <span v-show="logisticsScoreLevel<=2">差评</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      star1:require('../../assets/img/star_1.png'),
      star2:require('../../assets/img/star_2.png'),
      allGoodsScoreLevel:5,
      allGoodsScore:[{id:1,isChecked:true},{id:2,isChecked:true},{id:3,isChecked:true},{id:4,isChecked:true},{id:5,isChecked:true}],
      serviceScoreLevel:5,
      serviceScore:[{id:1,isChecked:true},{id:2,isChecked:true},{id:3,isChecked:true},{id:4,isChecked:true},{id:5,isChecked:true}],
      logisticsScoreLevel:5,
      logisticsScore:[{id:1,isChecked:true},{id:2,isChecked:true},{id:3,isChecked:true},{id:4,isChecked:true},{id:5,isChecked:true}],
      orderGoodsItem:[],
      isAppend:0,
      tenantName:'',
      time:''
    }
  },
  mounted:function(){
    var t_=this
    t_.isAppend=t_.$route.query.isAppend
    t_.getOrder()
  },
  methods:{
    toGoods:function(web,id,name){
      var t_=this
      var url='http://'+web+'/goodsdetails?goodsId='+id
      window.open(url,'_blank')
    },
    submit:function(){
      var t_=this
      var item=[]
      for(var i=0;i<t_.orderGoodsItem.length;i++){
        var item0bj={
          evalue:t_.orderGoodsItem[i].txt,
          id:t_.orderGoodsItem[i].id,
          level:t_.orderGoodsItem[i].level,
          path:t_.orderGoodsItem[i].imgList_
        }
        item.push(item0bj)
      }
      if(t_.isAppend){
        for(var i=0;i<item.length;i++){
          delete item[i].level
        }
      }
      var data0bj={
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        orderId:t_.$route.query.id,
        memberEvaluationNumber:1,
        conformgoods:t_.allGoodsScoreLevel,
        attitude:t_.serviceScoreLevel,
        satisfied:t_.logisticsScoreLevel,
        item:JSON.stringify(item)
      }
      if(t_.isAppend){
        delete data0bj.conformgoods
        delete data0bj.attitude
        delete data0bj.satisfied
        data0bj.memberEvaluationNumber=2
      }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/addEvaluation`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          t_.$router.push({
            name: 'myEvaluation',
          });
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    uploadImgFn:function(e,id){
      var t_=this
      let file = e.target.files
      var isOk=false
      t_.orderGoodsItem.forEach(function(item,index){
        if(item.id==id){
          if(item.imgList.length+file.length>5){
            isOk=true
            t_.$message({
              message:'最多选择5张图片',
              center:true,
              type:'warning'
            })
          }
        }
      },t_)
      if(isOk)return
      for(var i=0;i<file.length;i++){ 
        let param = new FormData()
        param.append('file',file[i],file[i].name)
        param.append('channel',2)
        param.append('orderId',this.$route.query.id)
        param.append('retailOrderItemId',id)
        param.append('tamp',localStorage.tamp?localStorage.tamp:'')
        let config = {
          headers:{'Content-Type':'multipart/form-data'}
        }
        axios.post(`${ip}formWorkInterface/uploadImg`,param,config).then(res=>{
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            t_.orderGoodsItem.forEach(function(item,index){
              if(item.id==res.data.id){
                res.data.url='data:image/png;base64,'+res.data.url
                item.imgList.push(res.data.url)
                item.imgList_.push(res.data.url1)
              }
            },t_)
            $('input[type="file"]').val("")
          }else{
            t_.$message({
              message:'上传图片失败，请重新上传',
              center:true,
              type:'warning'
            })
          }
        })
      }
      
    },
    getOrder:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        orderId:t_.$route.query.id
      })
      axios.post(`${ip}formWorkInterface/getOrder`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          res.data.orderItem.forEach(function(item,index){
            t_.$set(item,'imgList', [])
            t_.$set(item,'imgList_', [])
            t_.$set(item,'txt', '')
            t_.$set(item,'level', 5)
            t_.$set(item,'goodsScore', [{id:1,isChecked:true},{id:2,isChecked:true},{id:3,isChecked:true},{id:4,isChecked:true},{id:5,isChecked:true}])
          },t_)
          t_.orderGoodsItem=res.data.orderItem
          t_.tenantName=res.data.tenantName
          t_.time=res.data.time
        }
      })
    },
    goodsScoreFn:function(idx1,n,idx2){
      var t_=this
      t_.orderGoodsItem[idx1].level=n
      for(var i=0;i<t_.orderGoodsItem[idx1].goodsScore.length;i++){
        if(n>i){
          t_.orderGoodsItem[idx1].goodsScore[i].isChecked=true
        }else{
          t_.orderGoodsItem[idx1].goodsScore[i].isChecked=false
        }
      }
    },
    allGoodsScoreFn:function(n,idx){
      var t_=this
      t_.allGoodsScoreLevel=n
      for(var i=0;i<t_.allGoodsScore.length;i++){
        if(n>i){
          t_.allGoodsScore[i].isChecked=true
        }else{
          t_.allGoodsScore[i].isChecked=false
        }
      }
    },
    serviceScoreFn:function(n,idx){
      var t_=this
      t_.serviceScoreLevel=n
      for(var i=0;i<t_.serviceScore.length;i++){
        if(n>i){
          t_.serviceScore[i].isChecked=true
        }else{
          t_.serviceScore[i].isChecked=false
        }
      }
    },
    logisticsScoreFn:function(n,idx){
      var t_=this
      t_.logisticsScoreLevel=n
      for(var i=0;i<t_.logisticsScore.length;i++){
        if(n>i){
          t_.logisticsScore[i].isChecked=true
        }else{
          t_.logisticsScore[i].isChecked=false
        }
      }
    },
  }
}
</script>
<style>
  .evaluate_box{
    width: 1068px;
    border: 1px solid #ddd;
    background: #fff;
    position: relative;
  }
  .evaluate_box h2{
    background: #f8f8f8;
    height: 36px;
    line-height: 36px;
    border-bottom: 1px solid #ddd;
  }
  .evaluate_box h2 span{
    color:#999;
    margin-left: 20px;
  }
  .evaluate_item>ul>li{
    padding: 20px;
  }
  .evaluate_item_pic{
    width: 100px;
    height: 100px;
    border: 1px solid #ddd;
    margin-bottom: 4px;
  }
  .evaluate_item_pic img{
    width:100px;
    height: 100px;
  }
  .evaluate_item_name{
    width: 100px;
    line-height: 20px;
    color:#666;
    text-align: center;
    cursor: pointer;
  }
  .evaluate_item_price{
    line-height: 20px;
    color:#333;
    text-align: center;
  }
  .evaluate_goods{
    margin-right: 20px;
  }
  .evaluate_text{
    width: 638px;
  }
  .evaluate_describe textarea{
    width: 636px;
    height: 86px;
    border: 1px solid #ddd;
    margin-bottom: 5px;
  }
  .evaluate_describe p{
    text-align: right;
  }
  .evaluate_text_upload button{
    width: 84px;
    height: 21px;
    background: #99b9f4;
    border: 0;
    color:#fff;
    line-height: 5px;
    border-radius: 0;
  }
  .evaluate_text_upload_box{
    padding: 13px;
    width: 612px;
    height: 62px;
    border: 1px solid #ddd;
  }
  .evaluate_text_upload_box li{
    width: 60px;
    height: 60px;
    border: 1px solid #ddd;
    margin-right: 10px;
  }
  .evaluate_text_upload_box li img{
    width: 60px;
    height: 60px;
  }
  .evaluate_text_upload_box .evaluate_text_upload_plus{
    background: url(../../assets/img/plus.png);
    cursor: pointer;
    border: 1px dashed #ddd;
  }
  .evaluate_text_upload_plus input{
    width: 60px;
    height: 60px;
    opacity: 0;
  }
  .evaluate_score{
    margin-bottom: 10px;
  }
  .evaluate_score img{
    cursor: pointer;
  }
  .evaluate_score span{
    width: 28px;
    height: 15px;
    display: inline-block;
    color:#fff;
    line-height: 15px;
    padding-left: 7px;
    background: url(../../assets/img/evaluate_bg.png);
    margin-top:1px;
  }
  .scoreList{
    position: absolute;
    top:58px;
    right:60px;
  }
  .submit_box{
    text-align: right;
    margin-bottom: 15px;
  }
  .submit_box button{
    width: 72px;
    height: 32px;
    background: #e2331a;
    color:#fff;
    border: 0;
    border-radius: 5px;
    margin-right: 285px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/evaluate_order.vue